import _ from 'lodash';
import { ConsultDetail } from '../consult/consult';
import {Component, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
declare var $:any;

@Component({
	selector: 'container-consult-check',
	templateUrl: 'consult-check.html',
	styles: [`
    agm-map {
			height: 400px;
			width: 100%;
    }
  `],
})

export class ConsultcheckComponent implements AfterViewInit {
	@Input() latitude1: number;
	@Input() longitude1: number;
	@Input() zoom1: number;
	@Input() latitude2: number;
	@Input() longitude2: number;
	@Input() zoom2: number;
	@Input() uploader;
	@Input() cargoList: Array<any>;
	@Input() consultDetail;
	@Input() consultDetailEmpty: boolean;
	@Input() isCstCargo: boolean;
	@Input() isInsCargo: boolean;
	@Input() dontTwoFold: boolean;
	@Input() isReferCargo: boolean;
	@Input() isDangerCargo: boolean;
	@Input() isCfsFclAsked: boolean;
	@Input() isCfsLclAsked: boolean;
	@Input() minTemp: number;
	@Input() maxTemp: number;
	@Input() tempUnit: string;
	@Input() measuring: boolean;
	@Output() backToEdit = new EventEmitter();  

	constructor() {}

	ngAfterViewInit(): void {
	
	// Map
		$('.map-container')
			.click(function(){
			$(this).find('iframe').addClass('clicked')})
			.mouseleave(function(){
			$(this).find('iframe').removeClass('clicked')});
	}

	modal() {
		if($('.consult-request-modal').hasClass('open')) {
			$('.consult-request-modal').removeClass('open');
		} else {
			$('.consult-request-modal').addClass('open');
		}	
	}

	consultRequestPost() {
		this.uploader.uploadAll();
		this.modal();
	}

	clickBackToEdit() {
		this.backToEdit.emit('true');
	}

}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/consult/consult-check.ts